// Results / ROAS proof band. Plural, unnamed customers + "up to 4x+" per the
// locked message (/homepage-message.md) — defensible, no single-client exposure.
const PROOF_ADS = [
  '/feature-renders/moodboard_a2b475c716-8ece1ec0.webp',
  '/feature-renders/moodboard_6ae6c75ccb-40b4b79c.webp',
  '/feature-renders/moodboard_3291e2b4e4-1ddd49ec.webp',
  '/feature-renders/moodboard_86baf0c73b-bd30d591.webp',
  '/feature-renders/moodboard_aa60f3c1ff-732149e3.webp',
  '/feature-renders/moodboard_95b559f834-26ca870a.webp',
];

const STATS = [
  { value: 'up to 4x+', label: 'Return on ad spend' },
  { value: '$0', label: 'Spent on designers or agencies' },
  { value: 'Minutes', label: 'From product to posted ad' },
];

export default function Showcase() {
  return (
    <section id="results" className="py-24 md:py-32 bg-white">
      <div className="w-full px-6 md:px-10 lg:px-16">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-light text-primary text-xs font-semibold tracking-wider uppercase mb-6">
            <i className="ri-line-chart-line" />
            Results
          </span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-dark leading-[1.1] tracking-tight mb-5">
            Our customers don't get images.
            <br />
            <span className="text-primary">They get returns.</span>
          </h2>
          <p className="text-dark-muted text-base md:text-lg leading-relaxed">
            Sharper creative plus smarter targeting means more revenue for every
            dollar you spend. No photoshoots, no agency retainers.
          </p>
        </div>

        {/* Stat row */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-4xl mx-auto mb-16">
          {STATS.map((s) => (
            <div
              key={s.label}
              className="text-center rounded-2xl border border-surface-dark/30 bg-surface p-7 shadow-[0_10px_35px_-20px_rgba(15,15,30,0.2)]"
            >
              <span className="block font-display text-3xl md:text-4xl font-bold text-primary mb-1.5">{s.value}</span>
              <span className="text-sm text-dark-muted">{s.label}</span>
            </div>
          ))}
        </div>

        {/* Real ad renders — proof of quality */}
        <div className="grid grid-cols-3 md:grid-cols-6 gap-3 max-w-5xl mx-auto mb-12">
          {PROOF_ADS.map((src, i) => (
            <div key={src} className="rounded-xl overflow-hidden aspect-square bg-surface gradient-stroke shadow-md">
              <img src={src} alt={`Customer ad ${i + 1}`} className="w-full h-full object-cover" loading="lazy" />
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href="/auth/sign-up"
            className="inline-flex items-center gap-3 px-8 py-4 bg-primary hover:bg-primary-hover text-white text-base font-bold rounded-full transition-all group shadow-lg shadow-primary/20"
          >
            Start Free
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>
    </section>
  );
}
